import styled from 'styled-components';

import { ReactComponent as Arrow } from 'assets/images/arrow-forw.svg';
import { ReactComponent as BaseCarIcon } from 'assets/images/autos/icon-car.svg';
import { ReactComponent as Chevron } from 'assets/images/chevron-small.svg';
import { ReactComponent as CompanyGroup } from 'assets/images/company-group.svg';
import { ReactComponent as CopyPaste } from 'assets/images/copy-paste.svg';
import { ReactComponent as Group } from 'assets/images/group.svg';
import { ReactComponent as Guest } from 'assets/images/invite.svg';
import { ReactComponent as Money } from 'assets/images/money.svg';
import { ReactComponent as Ticket } from 'assets/images/ticket.svg';
import Button from 'components/Buttons/Button';
import ListItem from 'components/List/ListItem';

export const Item = styled(ListItem)`
  border-radius: 16px;
  margin-bottom: 20px;

  background: white;
  box-shadow: 0px 5px 10px rgba(33, 34, 36, 0.04);

  cursor: pointer;

  @media ${({ theme }) => theme.device.desktop} {
    margin-bottom: 0;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  width: 100%;
  height: 100%;
  padding: 8px;
  border-radius: 16px;
`;

export const TravelProcessing = styled.div`
  background-color: #fff0ca;
  font-size: 12px;
  color:rgb(167, 125, 18);
  padding: 8px;
  border-radius: 8px;
  margin-bottom: 14px;
`;

export const Travel: any = styled.div`
  display: flex;
  justify-content: space-between;
  height: 58px;
`;
Travel.Info = styled.div``;
Travel.Destination = styled.h2`
  font-size: 14px;
  font-weight: 600;
  color: #332927;
  line-height: 140%;
  margin-bottom: 2px;
`;
Travel.Date = styled.p`
  font-size: 12px;
  font-weight: 400;
  line-height: 130%;
  color: #706967;
`;
Travel.Status = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
`;
type TravelImageProps = {
  $image: string;
};
export const TravelImage = styled.div<TravelImageProps>`
  width: 100%;
  height: 181px;
  border-radius: 8px;
  margin-bottom: 12px;
  background-position: center;
  background-size: cover;
  background-image: ${({ $image }) => `url(${$image}), url(https://images.rappi.com/web/travel/heros/hero-flight.svg)`};
`;

export const TravelInfo = styled.span`
  font-size: 12px;
  letter-spacing: 0.2px;
  color: #626e75;
`;

export const Code: any = styled.div`
  display: flex;
  flex-direction: row;
  align-self: stretch;
  align-items: center;
  gap: 10px;
`;
Code.Label = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #332927;
  line-height: 130%;
  & strong {
    font-weight: 600;
  }
`;
Code.Item = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px;
  gap: 2px;
  width: 100%;
  margin-bottom: 24px;
`;
export const IconRappi = styled(Ticket)`
  width: 20px;
  height: 45px;
`;
Code.Icon = styled.div`
  width: 24px;
  height: 24px;
  align-self: flex-start;
  align-items: center;
  display: flex;
`;
Code.Copy = styled.div`
  self-align: flex-end;
`;
export const IconCopyPaste = styled(CopyPaste)`
  width: 24px;
  height: 24px;
`;
export const AirIcon = styled.img`
  height: 20px;
  max-width: 30px;
`;

export const Divider = styled.div`
  height: 1px;
  background: #dbdbdb;
  margin: 0 8px 24px;
`;
export const Footer = styled.div`
  margin: 0 8px 8px;
`;

export const ETicket = styled.span`
  font-size: 12px;
  line-height: 1.33;
  letter-spacing: 0.2px;
  color: #626e75;
  margin-bottom: 32px;
`;

export const InfoContainer = styled.div`
  padding: 0 8px;
`;

export const Info: any = styled.div`
  display: flex;
  margin-bottom: 16px;
  justify-content: space-between;
  align-items: center;
`;
Info.User = styled.div`
  font-size: 14px;
  color: #332927;
`;
Info.Group = styled.div`
  font-size: 14px;
  color: #332927;
  display: flex;
  align-items: center;
`;
Info.GroupIcon = styled(CompanyGroup)`
  color: #706967;
  width: 16px;
  height: 16px;
  margin-right: 4px;
`;

export const Title = styled.div`
  font-size: 16px;
  line-height: 1.2em;
  font-weight: 600;
  color: #252d31;
  display: flex;
`;

export const Icon = styled.img`
  height: 14px;
  padding-right: 14px;
`;

export const SubTitle = styled.div`
  display: flex;
  flex-direction: row;
  height: 16px;
  font-size: 12px;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: 0.2px;
  margin-top: 20px;
  color: #626e75;
`;

export const ReportLabel = styled.div`
  margin-left: auto;
  color: #626e75;
`;

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  opacity: 0.3;
  border-bottom: solid 1px #626e75;
  margin-top: 10px;
  margin-bottom: 8px;
`;

export const Expenses: any = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

Expenses.Value = styled.span`
  height: 24px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5;
  color: #252d31;
`;

Expenses.Count = styled.span`
  height: 16px;
  font-size: 12px;
  line-height: 1.33;
  letter-spacing: 0.2px;
  margin-left: auto;
  color: #626e75;
`;

export const TravelCardHeader = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 24px;
`;

export const UserLabel = styled.span`
  display: inline-flex;
  align-items: center;
  align-self: flex-end;
  font-size: 14px;
  color: #939da3;

  margin-left: 8px;
`;

export const GroupIcon = styled(Group)`
  margin-right: 4px;
`;

export const GuestIcon = styled(Guest)`
  margin-right: 4px;
`;

export const CarIcon = styled(BaseCarIcon)`
  margin-right: 14px;
  width: 18px;
  height: 16px;
  vertical-align: top;
`;

export const MoneyIcon = styled(Money)`
  width: 18px;
  margin-right: 9px;
`;

export const ArrowIcon = styled(Arrow)`
  width: 16px;
  height: 16px;
  margin: 0 5px;
  vertical-align: middle;
`;

export const TravelDestination = styled.div``;

export const AcceptButton = styled(Button)``;

export const Details: any = styled.div`
  & p {
    color: #332927;
    font-size: 14px;
    line-height: 140%;
    font-weight: 400;
    margin: 16px 0;
    &:last-child {
      margin-bottom: 0;
    }
  }
`;
Details.Bar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
Details.Divider = styled.div`
  height: 1px;
  margin: 16px 0;
  background: #f4f4f4;
`;

export const DropdownChevron = styled(Chevron)`
  width: 16px;
  height: 16px;
`;

type ToggleProps = {
  $detailsOpen: boolean;
};

export const ToggleDetails = styled.button<ToggleProps>`
  display: inline-block;
  background-color: transparent;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.5;
  letter-spacing: normal;
  color: #626e75;
  cursor: pointer;

  & ${DropdownChevron} {
    width: 10px;
    height: 10px;
    margin-left: 32px;
    vertical-align: middle;
    transform: ${({ $detailsOpen }) => ($detailsOpen ? 'rotate(270deg)' : 'rotate(90deg)')};
  }
`;
